var _g, _defs;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgTelegram = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3245)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
    fill: "url(#paint0_linear_1_3245)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.62124 7.91555C5.9534 6.89946 7.50854 6.2296 8.28666 5.90595C10.5083 4.98187 10.97 4.82135 11.2709 4.81605C11.3371 4.81488 11.485 4.83129 11.5809 4.90906C11.6618 4.97473 11.6841 5.06345 11.6947 5.12571C11.7054 5.18798 11.7187 5.32982 11.7081 5.44065C11.5877 6.70563 11.0668 9.77543 10.8018 11.1922C10.6896 11.7917 10.4688 11.9928 10.255 12.0124C9.79046 12.0552 9.43769 11.7054 8.98772 11.4104C8.28362 10.9489 7.88584 10.6616 7.20239 10.2112C6.41254 9.69069 6.92456 9.40462 7.3747 8.93709C7.4925 8.81474 9.53943 6.9529 9.57905 6.784C9.584 6.76288 9.5886 6.68414 9.54182 6.64256C9.49505 6.60098 9.42601 6.6152 9.37619 6.62651C9.30557 6.64254 8.18075 7.386 6.00174 8.85689C5.68246 9.07613 5.39328 9.18295 5.13417 9.17735C4.84853 9.17118 4.29907 9.01585 3.8906 8.88307C3.3896 8.72022 2.99142 8.63411 3.02609 8.35754C3.04415 8.21348 3.24253 8.06615 3.62124 7.91555Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_3245",
    x1: 8,
    y1: 0,
    x2: 8,
    y2: 15.8813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3245"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTelegram, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/telegram.2ce7b13f.svg";
export { ForwardRef as ReactComponent };